module.exports = __webpack_public_path__ + "4e20ffe67752c979bd2380ecb2e2800e.svg";